<template>
    <div class="privacy-req-scroller" v-html="paragraph.text"> </div>
</template>

<script>
export default {
  name: 'PrivacyScroller',
  watch: {
    started () {
      this.init()
    }
  },
  data () {
    return {
      isEnd: false,
      inited: false,
      cmpStarted: false,
      needYScroll: true
    }
  },
  props: {
    paragraph: {type: Object}
  }
}
</script>

<style lang="scss">
    .privacy-req-scroller {
        text-align: left;
        padding: 2px 10px;
        min-height: 50px;
        font-family: arial;
        font-size: 11px;
    }

    .scroll-area-force-visible-y-bar {
        .ps__scrollbar-y-rail {
            opacity: 1 !important;
            background-color: rgb(238,238,238) !important;
            width:12px;
            .ps__scrollbar-y {
                max-width:6px;
            }
        }
    }

    .scroll-area {
        background: white;
        border:1px solid silver;
        position: relative;
        margin: auto;
        margin-bottom:3px !important;
        width: auto;
        min-height: 50px;
        font-family: arial;
        font-size: 11px;
    }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyScroller.vue